import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";
import { BASIC_INITIAL_STATE } from "@usas/ui-web/utils/HttpHelper";

const putGroupMemberStepStatusData = (workflowId, groupMemberStatusObj, state, setState) => {
  if (workflowId > 0 && groupMemberStatusObj) {
    const api = initApi(API_NAMES.COMMON, state, setState);
    const workflowIdForUrl = encodeURIComponent(workflowId);
    const url = `/Workflow/${workflowIdForUrl}/GroupAdmin`;

    return api.executeObject ? api.executeObject(url, 'PUT', groupMemberStatusObj) : null;
  }
};

const INITIAL_GROUP_MEMBER_WORKFLOW_STATE = {
  ...BASIC_INITIAL_STATE
};

const GroupMemberWorkflowData = {
  INITIAL_GROUP_MEMBER_WORKFLOW_STATE,
  putGroupMemberStepStatusData
};

export default GroupMemberWorkflowData;